module.exports = __webpack_public_path__ + "static/media/lanzamiento_small.f004b93e.png";